<template>
  <div>
    <v-row class="mr-auto ml-auto" v-if="!stockListLoading"  >
      <v-col  v-for="item in stockList" :key="item.id" cols="12" md="6" sm="6" lg="4" xl="3">
        <v-card hover color="#f8f8fa">
          <v-carousel
              class="ml-auto mr-auto carousel-wrapper"
              :show-arrows="false"
              v-if="findImages(item.files).images"
              cycle
              interval="5000"
              hide-delimiters
          >
            <v-carousel-item v-for="(data, i) in findImages(item.files).images" :key="i">
              <v-img :src="data" alt=""
                     class="carousel-image"
                     contain
                     @click="goProductDetail(item.code)"
              />
            </v-carousel-item>
          </v-carousel>
          <div v-else
               @click="goProductDetail(item.code)"
               style="display: flex;
                  justify-content: center; align-items: center;">
            <img style="height: 275px; padding: 15px;" src="@/assets/images/no_image2.jpg">
          </div>
          <v-card-title @click="goProductDetail(item.code)" class="truncate-title fs-4">{{item.name}}</v-card-title>
          <v-card-subtitle @click="goProductDetail(item.code)" class="fs-5 text-start">Stok Kodu : <span class="font-weight-semibold">{{item.code}}</span> <p v-if="item.producerCode">Üretici Kodu : <span class="font-weight-semibold">{{item.producerCode}}</span></p> <p v-else style="color: #f8f8fa"> asdsa</p></v-card-subtitle>
          <v-card-text @click="goProductDetail(item.code)">
            <div class="fs-5 row">
              <div>
                <span class="text-black">Bakiye</span>:
                <span class="fw-semibold">{{ item.balance }}</span>
              </div>
              <div>
                <span class="text-black">Birim</span>:
                <span class="fw-semibold">{{ item.unit1 }}</span>
              </div>
              <div>
                <span class="text-black">Koli İçeriği</span>:
                <span class="fw-semibold">{{ item.denominator1 }}</span>
              </div>
              <div>
                <span class="text-black">Dövizli Fiyatı</span>:
                <span class="fw-semibold">{{ item.currencyVatExcludedPrice + ' ' + item.currency }}</span>
              </div>
              <div class="mt-3">
                <span v-if="item.discount1 !== 0" class="fs-4 fw-semibold text-black">
                  ₺{{ numberConverter(item.discountUnitPrice) }}
                </span>
                <span class="fs-4 me-3" :class="{ 'text-decoration-line-through': item.discount1 !== 0, 'fw-semibold text-black': item.discount1 === 0 }">
                  ₺{{ numberConverter(item.unitPrice) }}
                </span>
              </div>
            </div>
          </v-card-text>

          <v-card-actions class="justify-center">
            <div class="d-flex justify-content-around">
                  <v-btn
                      class="pb-2 me-1"
                      v-bind="attrs"
                      v-on="on"
                      icon
                      color="black"
                      @click="openStockDetailDalog(item)"
                  >
                    <v-icon dense> mdi-warehouse</v-icon>
                  </v-btn>
              <input
                  v-model="item.quantity"
                  :min="1"
                  class="form-control form-control-md text-left"
                  style="width: 50px; height: 28px; margin-right: 10px;"
                  @keydown.enter.prevent="e => addToCart(item, item.quantity)"
                  @change="e => (item.quantity = e.target.value)"
                  v-if="
              cartList.filter(e => e.stockCode === item.code).length < 1
            "
              />
<!--              <v-btn outlined block small >-->
<!--                <v-icon color="gray" class="mr-2" small> mdi-cart </v-icon>-->
<!--                <span class="fs-6 fw-medium">Sepete Ekle</span>-->
<!--              </v-btn>-->
              <input
                  v-if="cartList.filter(e => e.stockCode === item.code).length > 0"
                  :value="cartList.find(e => e.stockCode === item.code).quantity"
                  :min="1"
                  class="form-control form-control-md text-left"
                  style="width: 50px; height: 28px; margin-right: 10px;"
                  @keydown.enter.prevent="e => addToCart(item, e.target.value)"
                  @change="e => (item.quantity = e.target.value)"
              />
              <v-btn
                  small
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  style="width: 115px;"
                  @click="addToCart(item, item.quantity)"
                  v-show="
                  cartList.filter(e => e.stockCode === item.code).length <
                    1
                "
              >
                <v-icon color="gray" class="mr-1" small> mdi-cart </v-icon>
                <span class="fs-6 fw-medium">Sepete Ekle</span>
              </v-btn>


              <div
                  class="d-flex justify-content-center"
                  v-if="cartList.filter(e => e.stockCode === item.code).length > 0"
              >

                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        small
                        style="width:115px; margin-right: 10px;"
                        @click="addToCart(item, item.quantity)"
                    >
                      <v-icon color="gray" class="mr-2" small> mdi-cart </v-icon>
                      <span class="fs-6 fw-medium">Sepete Ekle</span>
                    </v-btn>

                <v-tooltip
                    bottom
                    v-if="
              cartList.filter(e => e.stockCode === item.code).length > 0
            "
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        small
                        icon
                        color="danger"
                        @click="cartStockRemove(item)"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>Sepetten Çıkar</span>
                </v-tooltip>
              </div>
            </div>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col
          cols="12"
          class="d-flex flex-column justify-content-center align-items-center"
      >
        <b-spinner
            variant="primary"
            size="xl"
            label="Text Centered"
        ></b-spinner>
        <span class="fs-4 fw-medium">
          {{ "Yükleniyor" }}
        </span>
      </v-col>
    </v-row>
    <ProductDetail
        :stock-code="productDetailStockCode"
        :showDialog="showProductDetailDialog"
        @dialogChange="e => (showProductDetailDialog = e)"
    ></ProductDetail>
    <StockDetailDialog
        :show-dialog="showStockDetailDailog"
        @dialogChange="e => (showStockDetailDailog = e)"
        :stockCode="stockCodeProp"
    ></StockDetailDialog>
  </div>
</template>
<script>
import {mapActions, mapState} from "vuex";
import {numberConverter} from "../../../../helpers";
import ProductDetail from "@/pages/views/product/ProductDetail.vue";
import {showProcessErrorMessage} from "@/state/alertHelpers";
import Swal from "sweetalert2";
import StockDetailDialog from "@/components/product-search/dialogs/StockDetailDialog.vue";

export default {
  name: "ResultsCardViewTest",
  components: {
    StockDetailDialog,
    ProductDetail,
  },
  data() {
    return {
      on: {},
      attrs: {},
      showProductDetailDialog: false,
      showStockDetailDailog: false,
      productDetailStockCode: null,
      muadilKodDialog: false,
      muadilKodDialogData: null,
      stokOzellikDialog: false,
      stokOzellikDialogData: null,
      showStockActionsDialog: false,
      stockCodeProp: null,
      currentCodeProp: null,
      stockSearchTableKey: 0,
      stockAmount: 1,
    };
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("stock", [
      "stockList",
      "stockListLoading",
        "noStockMessage",
    ]),
    ...mapState("cart", ["cartList", "current","cartListMetaData"]),
  },
  methods: {
    numberConverter,
    ...mapActions("cart", [
      "addProductToCartList",
      "removeProductFromCartList",
      "changeQuantityOfProduct",
      "stockToCartAdd",
      "cartStockUpdate",
      "fetchSingleCartList",
      "cartStockDelete"
    ]),
    findImages(item) {
      let imageSource = null;
      let images = null;
      let imageTypes = ['jpeg', 'jpg', 'gif', 'png',"webp","svg","JPEG","JPG","GIF","PNG","WEBP","SVG","bmp","BMP","tiff","TIFF","ico","ICO","svgz","SVGZ","heif","HEIF","heic","HEIC","avif","AVIF","apng","APNG","jfif","JFIF","pjpeg","PJPEG","pjp","PJP","avif","AVIF","avifs","AVIFS"];
      if (item) {
        let allImages = item.filter((item) => imageTypes.some(type => item.fileUrl.includes(type)));
        images = allImages.map((e) => e.fileUrl)
        imageSource = allImages[0].fileUrl
      }
      return {imageSource, images}
    },
    expandImage(images) {
      this.$viewerApi({
        images: images,
      });
    },
    async addToCart(product, quantity = 1) {
      // quantity = product.selectedUnit * product.denominator1;
      // if (product.selectedUnit === 2 || product.selectedUnit === '2') {
      //   quantity = product.denominator1 * quantity;
      // }
      // if (product.discount1 > product.maxDiscount) this.isDiscountExceeded = true; else this.isDiscountExceeded = false;
      // product;
      if (quantity <= 0) {
        showProcessErrorMessage({
          title: "Ürün Ekleme Başarısız",
          text: "Miktar sıfırdan büyük olmalıdır",
          icon: "error",
          confirmButtonText: "Tamam"
        })
        return;
      }
      if (product.discount1 < 0 || product.discount2 < 0) {
        showProcessErrorMessage({
          title: "Ürün Ekleme Başarısız",
          text: "İndirim oranı sıfırdan büyük olmalıdır",
          icon: "error",
          confirmButtonText: "Tamam"
        })
        return;
      }
      if (!this.current) {
        await Swal.fire({
          title: "Ürün Ekleme Başarısız",
          text: "Cari listesinden cari seçimi yapmalısınız",
          icon: "error",
          confirmButtonText: "Tamam"
        });
      } else {
        if (this.user.userInfo.priceIntervention) {
          let originalPrice = null;
          if (typeof (product.unitPrice) === "string") {
            originalPrice = product.unitPrice.replace('.', '').replace(',', '.');
            originalPrice = parseFloat(originalPrice);
          } else {
            originalPrice = product.unitPrice
          }


          await this.stockToCartAdd({
            params: {
              userId: this.user.UserId,
              currentCode: this.current.code
            },
            body: {
              StockCode: product.code,
              Quantity: quantity,
              Unit: 1,
              Discount1: product.discount1,
              Discount2: product.discount2,
              isBasket: false,
              Description: null,
              UnitPrice: originalPrice,
              // isDiscountExceeded: this.isDiscountExceeded,
            }
          });
        } else {
          await this.stockToCartAdd({
            params: {
              userId: this.user.UserId,
              currentCode: this.current.code
            },
            body: {
              StockCode: product.code,
              Quantity: quantity,
              Unit: 1,
              Discount1: product.discount1,
              Discount2: product.discount2,
              isBasket: false,
              Description: null,
              // isDiscountExceeded: this.isDiscountExceeded,
            }
          });
        }
        this.stockAmount = 1;
      }
    },
    async cartStockRemove(product) {
      await this.cartStockDelete({
        params: {
          userId: this.user.UserId,
          currentCode: this.current.code,
          stockCode: product.code
          //basketCode: null //sepet Kodu ise yollanacak
        },
        body: {}
      }).then(async (response) => {
        if (response === true) product.quantity = null;
      }).catch((error) => {
        error;
      })
    },
    goProductDetail(stockCode) {
      this.showProductDetailDialog = true;
      this.productDetailStockCode = stockCode;
    },
    openStockDetailDalog(data) {
      this.stockCodeProp = data.code;
      this.showStockDetailDailog = true;
    },
  }
}
</script>

<style scoped>
.truncate-title {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
.carousel-wrapper {
  max-height: 275px; /* Görüntülerin yüksekliğini ayarlayabilirsiniz */
  padding-top: 5px;
}

.carousel-image {
  object-fit: cover;
  width: 100%;
  height: 60%; /* Yüksekliği ayarlayarak tüm resimlerin aynı boyutta görünmesini sağlayabilirsiniz */
}
</style>